module.exports = __webpack_public_path__ + "static/media/programs-header.ab22d9b5.jpg";